function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#1D998C",
  strokeWidth: 5.6,
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 28.8,
  cy: 28.8,
  r: 28.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.2 7.2l42.45 42.45"
}));

var SvgBan = function SvgBan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/ban.d59b255c.svg";
export { SvgBan as ReactComponent };